import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import roleService from '../../service/RoleService';
import { AspireAccessProvider } from '../../context/AspireAccessContext';

/**
 * Protected Layout Component using React Router v6+ Outlet pattern
 * This is the modern best practice for handling authentication in React Router
 *
 * Benefits:
 * - Single authentication check point
 * - Cleaner route structure
 * - Better performance (fewer component re-renders)
 * - Easier maintenance
 * - Follows React Router v6+ best practices
 */
const ProtectedLayout = () => {
    const location = useLocation();
    // Single authentication check for all protected routes
    if (!roleService.isAuthenticated()) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Render child routes using Outlet
    return (
        <AspireAccessProvider>
            <Outlet />
        </AspireAccessProvider>
    );
};

export default ProtectedLayout;
